export default __webpack_public_path__ + "static/media/theme7.efb87957.jpg";